import React from "react";

import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetConnectNulls } from "../../../widget-form/connect-nulls";
import { FormState } from "../../../widget-form/time-series-chart/form-state";
import { SettingsSectionFormField } from "../_field";
import { Legend } from "../_legend";
import { ResetToDefaultSection } from "../_reset-to-default-section";
import { SettingsSectionGrid } from "../_section-grid";
import { Thresholds } from "../_thresholds";
import { Labels } from "../_y-axis/labels";
import { Range } from "../_y-axis/range";

export interface TimeSeriesChartProps {
	settings: FormState;
}

export const TimeSeriesChart: React.FC<TimeSeriesChartProps> = ({ settings }) => (
	<div className="grid h-full grid-cols-3 gap-4">
		<div className="flex flex-col gap-4">
			<Legend legend={settings.fields.legend} />

			<Widget>
				<WidgetHeader className="uppercase" title="Visual">
					<FormFieldReset className="ml-auto" state={settings.fields.connectNulls} />
				</WidgetHeader>

				<WidgetBody card>
					<SettingsSectionGrid className="grid-cols-[auto_1fr]">
						<SettingsSectionFormField layout="horizontal" state={settings.fields.connectNulls}>
							<FormLabel>Connect Nulls</FormLabel>

							<WidgetConnectNulls
								connectNulls={settings.fields.connectNulls}
								name="dashboard-widget-settings-connect-nulls"
							/>
						</SettingsSectionFormField>
					</SettingsSectionGrid>
				</WidgetBody>
			</Widget>
		</div>

		<div className="flex flex-col gap-4">
			<Labels yAxis={settings.fields.yAxis} />

			<Range range={settings.fields.range} />
		</div>

		<div className="flex flex-col gap-4">
			<Widget>
				<WidgetHeader className="uppercase" title="Thresholds">
					<FormFieldReset className="ml-auto" state={settings.fields.thresholds} />
				</WidgetHeader>

				<WidgetBody card>
					<Thresholds
						mode={settings.fields.thresholds.fields.mode}
						thresholds={settings.fields.thresholds.fields.steps}
					/>
				</WidgetBody>
			</Widget>

			<ResetToDefaultSection onClick={() => settings.setInput(FormState.initial)} />
		</div>
	</div>
);
